export default function openCurrentSlide() {
    if(document.querySelector(".gallery")) {
        const photos = document.querySelectorAll(".gallery__item");
        const photosModal = document.querySelectorAll(".gallery__slide");

        photos.forEach(photo => {
            photo.addEventListener("click", () => {
                const pagination = document.querySelector(".gallery-pagination")
                let paginationId = 0;

                pagination.childNodes.forEach(paginationItem => {
                    if(paginationItem.classList.contains("swiper-pagination-bullet-active")) {
                        paginationItem.classList.remove("swiper-pagination-bullet-active");
                    }

                    paginationItem.setAttribute("data-pagination-id", paginationId++);

                    if(photo.dataset.imageId === paginationItem.dataset.paginationId) {
                        paginationItem.classList.add("swiper-pagination-bullet-active");
                    }
                });

                photosModal.forEach(photoModal => {
                    if(photoModal.classList.contains("swiper-slide-active")) {
                        photoModal.classList.remove("swiper-slide-active");
                    }
                    
                    if(photo.dataset.imageId === photoModal.dataset.slideId) {
                        const widthSlide = Number(photoModal.style.width.replace("px", ""));
                        const qtdSlide = Number(photoModal.dataset.slideId);
                        const currentSlide = -(widthSlide * qtdSlide);
                        const slideContainer = document.querySelector(".swiper-wrapper");

                        slideContainer.style.transform = `translate3d(${currentSlide}px, 0, 0)`;

                        photoModal.classList.add("swiper-slide-active");
                    }
                });
            });
        });
    }
}